module.exports = __webpack_public_path__ + "img/treatments-1.1c5526a7.png";